import { createSelector } from "reselect"
import { get, map, some, chain } from "lodash"
import { getRawTopic, getModels, getSelectedModel } from "modules/research-topic-root/selectors"
import { getContentSets } from "selectors/contentSets"
import { Creators as SegmentsCreator } from "modules/compare-segments-root/model"
import { menuContentSets } from "helpers/menu"
import { getBaseComparisonTypes } from "helpers/comparison"
import { getInstrument } from "./instrument"
import { computeAttributionMethod } from "helpers/risk"

export const getRawSecurities = (state) => get(state, "global.data.securitiesDescriptors.data.model")
export const getResearchTopicExperiments = state => get(state, "global.data.topicExperiments.data")
export const getHedges = (state) => get(state, "modules.researchTopic.hedges", [])
export const getHedgeItem = (state) => get(state, "modules.researchTopic.hedgeItem")
const getAccount = (state) => get(state, "global.selected.account")

export const getSummaryPanelOpen = (state) => get(state, "modules.researchTopic.summaryPanelOpen")
export const getRenameExperimentOpen = (state) => get(state, "modules.researchTopic.renameExperiment")
export const getSelectedExperiment = (state) => get(state, "modules.researchTopic.selected.experiment")
export const getSelectedSegment = (state) => get(state, "modules.researchTopic.selected.segment")
export const getExperimentToUpdate = (state) => get(state, "modules.researchTopic.experimentToUpdate")
export const getSavedMetrics = (state) => get(state, "modules.researchTopic.savedMetrics")
export const getSavedCompositionGroup = (state) => get(state, "modules.researchTopic.savedCompositionGroup")
export const getSavedTopicSummaryGroup = (state) => get(state, "modules.researchTopic.savedTopicSummaryGroup")
export const getSelectedComparisonType = state => get(state, "modules.researchTopic.selectedComparisonType", {})

const getCoverageData = (n) => state => get(state, `global.data.topicComparisonItemCoverage${n}.data.model.simulation.coverage`)

export const getModeledItems = createSelector(
  [getCoverageData(1), getCoverageData(2), getCoverageData(3), getCoverageData(4)],
  (data1, data2, data3, data4) => map([data1, data2, data3, data4], data => some(data, elem => get(elem, "summary.percentGmvAvailable", 0) !== 0)))

export const getBaseUrl = createSelector(
  [getRawTopic, getAccount],
  (topic, account) => `/${account}/t/${topic.id}/experiments`,
)

export const getModelName = createSelector(
  [getModels, getSelectedModel],
  (models, selectedModelId) => chain(models).find(model => model.id === selectedModelId).get("name", "").value(),
)

export const SEARCH_ITEMS_ACTIONS = () => ({
  security: {
    mainAction: item => () => SegmentsCreator.addComparisonItem(item, null, "research-topic-comparison-added"),
  },
  portfolio: {
    mainAction: item => () => SegmentsCreator.addComparisonItem(item, null, "research-topic-comparison-added"),
  },
  benchmark: {
    mainAction: item => () => SegmentsCreator.addComparisonItem(item, null, "research-topic-comparison-added"),
  },
  index: {
    mainAction: item => () => SegmentsCreator.addComparisonItem(item, null, "research-topic-comparison-added"),
  },
  experiment: {
    mainAction: item => () => SegmentsCreator.addComparisonItem(item, null, "research-topic-comparison-added"),
  },
})

export const getSearchItemsActions = createSelector(
  [getInstrument],
  ({ securityId: instrument }) => SEARCH_ITEMS_ACTIONS(instrument),
)

export const getComparisonTypes = createSelector(
  [getContentSets],
  (contentSets) => {
    return [
      { id: "summary", name: "Topic Summary", base: true },
      ...getBaseComparisonTypes(false),
      ...menuContentSets(contentSets),
    ]
  },
)

// Research-topic cannot be active
const getIsActive = () => false
export const getAttributionMethod = createSelector(
  [getIsActive],
  computeAttributionMethod,
)
